<template>
    <eod-card>
        <template v-slot:header>
            <div class="px-4 py-2">
                <v-tabs v-model="activePage" fixed-tabs>
                    <draggable :value="value.content.pages" @change="tabDragged" group="pages"
                        class="v-slide-group__content v-tabs-bar__content" draggable=".dragitem">
                        <template v-slot:header>
                            <v-tab :key="0">
                                <v-avatar :color="value.content.pages[0].statusCode.color" size="24" class="mr-2">
                                    <v-icon small :dark="value.content.pages[0].statusCode.textColor == 'white'">{{
                                        value.content.pages[0].statusCode.icon }}</v-icon>
                                </v-avatar>
                                {{ value.content.pages[0].name }}
                            </v-tab>
                        </template>
                        <v-tab v-for="(page, index) in value.content.pages.slice(1).slice(0, -1)" :key="index + 1"
                            class="dragitem">
                            <template v-if="page.statusCode">
                                <v-avatar :color="page.statusCode.color" size="24" class="mr-2">
                                    <v-icon small :dark="page.statusCode.textColor == 'white'">{{ page.statusCode.icon
                                        }}</v-icon>
                                </v-avatar>
                            </template>
                            {{ page.name }}
                        </v-tab>
                        <template v-slot:footer>
                            <v-tab :key="value.content.pages.length - 1">
                                <v-avatar :color="value.content.pages[value.content.pages.length - 1].statusCode.color"
                                    size="24" class="mr-2">
                                    <v-icon small
                                        :dark="value.content.pages[value.content.pages.length - 1].statusCode.textColor == 'white'">{{
                                            value.content.pages[value.content.pages.length - 1].statusCode.icon }}</v-icon>
                                </v-avatar>
                                {{ value.content.pages[value.content.pages.length - 1].name }}
                            </v-tab>
                        </template>
                    </draggable>
                    <div class="d-flex align-items-center">
                        <eod-btn @click="addPage">
                            <v-icon left>mdi-plus</v-icon>
                            Stap toevoegen
                        </eod-btn>
                    </div>
                </v-tabs>
            </div>
        </template>
        <v-card-text>
            <v-tabs-items v-model="activePage">
                <v-tab-item v-for="(page, index) in value.content.pages" :key="index" transition="fade-transition"
                    reverse-transition="fade-transition">
                    <eod-card class="mb-4" outlined title="Stap eigenschappen" icon="mdi-form-textbox" titleClass="grey lighten-4 mb-4">
                        <template v-slot:header-actions>
                            <eod-btn v-if="page.removeable" color="error" @click="isDeleteDialogVisible = true">
                                <v-icon left>mdi-trash-can-outline</v-icon>
                                Stap verwijderen
                            </eod-btn>
                        </template>
                        <v-card-text>
                            
                            <eod-statuscode-autocomplete class="mt-4" v-if="page.removeable" v-model="page.statusCode"
                                :items="settings.workflowStatusCodes.filter(item => item.workflow_enabled)"
                                return-object label="Type"
                                @input="val => updateStatusCode(page, val)"></eod-statuscode-autocomplete>
                            <eod-text-field class="mt-4" v-model="page.name" label="Naam van de stap*"
                                :rules="[val => $validator.required(val, 'Naam')]"
                                @keyup="page.nameCustom = true"></eod-text-field>
                                <eod-statuscode-autocomplete class="mt-4" v-model="page.workflowStatusCode"
                                :items="settings.statusCodes"
                                 label="Workflow status"
                                ></eod-statuscode-autocomplete>
                                
                            <eod-textarea class="mt-4" v-model="page.description"
                                label="Omschrijving van de stap"></eod-textarea>
                        </v-card-text>
                    </eod-card>
                    <eod-delete-dialog v-model="isDeleteDialogVisible"
                        :item="{ name: value.content.pages[activePage].name }"
                        @delete="value.content.pages.splice(activePage, 1); activePage--;"></eod-delete-dialog>
                    <eod-card class="mb-4" outlined title="Inhoud" icon="mdi-clipboard-edit-outline" titleClass="grey lighten-4 mb-4">
                        <template v-slot:header-actions v-if="['automation'].includes(page.statusCode.value)">
                            <eod-btn @click="isAddBlockDialogVisible = true">
                                <v-icon left>mdi-plus</v-icon>
                                Automatisatie toevoegen
                            </eod-btn>
                            <eod-dialog v-model="isAddBlockDialogVisible" title="Automatisatie toevoegen" hide-ok :inset="false" icon="mdi-plus" icon-color="primary">
                                <v-list>
                                    <v-list-item v-for="(component, componentIndex) in Object.values(componentsList).filter(c => c.automation == true)"
                                        :key="componentIndex" @click.stop="addCell(index, component)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ component.name }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </eod-dialog>
                        </template>
                        <v-card-text>
                            <eod-card outlined class="mb-4" v-for="(cell, cellIndex) in page.cells"
                                :key="'cell_' + cellIndex" :title="cell.name">
                                <template v-slot:header-actions v-if="['automation'].includes(page.statusCode.value)">
                                    <v-btn icon color="error" @click="page.cells.splice(cellIndex, 1)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                                </template>
                                <v-card-text>
                                    <component :is="componentsList[cell.typeId].configurationComponent"
                                        v-bind="componentProps"
                                        v-model="page.cells[cellIndex]" :template="value" :page="page" :active-page="index"
                                        @updateStep="updateStep">
                                    </component>
                                </v-card-text>
                            </eod-card>
                        </v-card-text>
                    </eod-card>
                    <eod-card outlined title="Knoppen" icon="mdi-button"
                        v-if="!['automation', 'end'].includes(page.statusCode.value)" titleClass="grey lighten-4 mb-4">
                        <v-card-text>
                            <eod-card outlined class="mb-4" title="Naar volgende stap">
                                <template v-slot:header-icon>
                                    <v-avatar color="success" size="28" class="mr-2">
                                        <v-icon small dark>mdi-send-outline</v-icon>
                                    </v-avatar>
                                </template>
                                <v-card-text>
                                    <eod-text-field class="mt-4" label="Tekst*"
                                        :value="page.textNextStepButton || 'Volgende'"
                                        @input="val => page.textNextStepButton = val"
                                        :rules="[val => $validator.required(val, 'Naam van \'Naar volgende stap\' knop')]"></eod-text-field>
                                </v-card-text>
                            </eod-card>
                            <eod-card outlined class="mb-4" title="Stap afwijzen" v-if="index > 0">
                                <template v-slot:header-icon>
                                    <v-avatar color="warning" size="28" class="mr-2">
                                        <v-icon small dark>mdi-close-octagon-outline</v-icon>
                                    </v-avatar>
                                </template>
                                <v-card-text>
                                    <v-checkbox label="Toon knop" v-model="page.showCancelFormButton"></v-checkbox>
                                    <template v-if="page.showCancelFormButton">
                                        <eod-text-field class="mt-4" :value="page.textCancelFormButton || 'Afwijzen'"
                                            @input="val => page.textCancelFormButton = val" label="Tekst*"
                                            :rules="[val => $validator.required(val, 'Naam van \'Stap afwijzen\' knop')]"></eod-text-field>
                                        <v-checkbox label="Verplicht motivatie ingeven"
                                            v-model="page.requireCancelFormMotivation"></v-checkbox>
                                    </template>
                                </v-card-text>
                            </eod-card>
                            <eod-card outlined title="Workflow annuleren">
                                <template v-slot:header-icon>
                                    <v-avatar color="error" size="28" class="mr-2">
                                        <v-icon small dark>mdi-close-octagon-outline</v-icon>
                                    </v-avatar>
                                </template>
                                <v-card-text>
                                    <v-checkbox label="Toon knop" v-model="page.showCancelWorkflowButton"></v-checkbox>
                                    <template v-if="page.showCancelWorkflowButton">
                                        <eod-text-field class="mt-4"
                                            :value="page.textCancelWorkflowButton || 'Workflow annuleren'"
                                            @input="val => page.textCancelWorkflowButton = val" label="Tekst*"
                                            :rules="[val => $validator.required(val, 'Naam van \'Workflow annuleren\' knop')]"></eod-text-field>
                                        <v-checkbox label="Verplicht motivatie ingeven"
                                            v-model="page.requireCancelWorkflowMotivation"></v-checkbox>
                                    </template>
                                </v-card-text>
                            </eod-card>
                        </v-card-text>
                    </eod-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
    </eod-card>
</template>

<script>
import draggable from 'vuedraggable';
import eodStatuscodeAutocomplete from './eod-statuscode-autocomplete.vue';
import eodDeleteDialog from './eod-delete-dialog.vue';
import { v4 as uuidv4 } from 'uuid';
export default {
    name: 'eod-workflow-editor',
    components: {
        draggable,
        eodStatuscodeAutocomplete,
        eodDeleteDialog
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                content: {
                    pages: []
                }
            })
        },
        componentProps: Object
    },
    data: () => ({
        isAddBlockDialogVisible: false,
        isDeleteDialogVisible: false,
        activePage: 0,
        settings: require('./../classes/settings'),
        componentsList: {
            fixed_form:
            {
                id: 'fixed_form',
                name: 'Vast formulier',
                configurationComponent: () => import('./forms/configuration/fixed-form'),
                settings: {},
            },
            form:
            {
                id:'form',
                name: 'Formulier',
                configurationComponent: () => import('./forms/configuration/form'),
                settings: {
                    template: null
                },
            },
            report:
            {
                id: 'report',
                name: 'Rapport versturen',
                automation: true,
                configurationComponent: () => import('./forms/configuration/report'),
                settings: {
                    formCellId: null,
                    overwriteStep: false,
                    mail: {
                        send: false,
                        subject: 'Rapport {{ project.name }}',
                        subjectAutoTranslate: true,
                        content: 'Beste {{user.first_name}}<br><br>In bijlage kunt u het rapport vinden voor {{project.name}}.',
                        contentAutoTranslate: true,
                        signature: 'Met vriendelijke groeten<br>Eye on Data',
                        signatureAutoTranslate: true,
                    }
                },
            },
            robaws:
            {
                id:'robaws',
                name: 'Verzenden naar Robaws',
                automation: true,
                configurationComponent: () => import('@/components/forms/configuration/robaws'),
                settings: {},
            },
        },
    }),
    methods: {
        createLinkedStep(step, defaults, before) {
            let stepIndex = this.getStepIndexById(step.id);
            let newStep = {
                id: uuidv4(),
                parentId: step.id,
                description: '',
                removeable: false,
                cells: [],
                ...defaults
            };

            stepIndex = before ? stepIndex : stepIndex + 1;
            this.value.content.pages.splice(stepIndex, 0, newStep);

            return stepIndex;
        },
        addCell(pageIndex, component){
            const cell = {
                id: uuidv4(),
                typeId: component.id,
                name: component.name,
                settings: { ...component.settings }
            };
            this.value.content.pages[pageIndex].cells.push(cell);

            this.isAddBlockDialogVisible = false;
        },
        addCellToStep(index, cell, defaults) {
            let newCell = {
                id: uuidv4(),
                typeId: 'fixed_form',
                name: cell.name,
                readonly: true,
                settings: {
                    cellId: cell.id,
                    type: defaults.type
                }
            };

            this.value.content.pages[index].cells.push(newCell);

            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        removeCellFromStep(index, cell) {
            let cells = this.value.content.pages[index].cells;
            for (let i = 0; i < cells.length; i++) {
                const linkedCell = cells[i];
                if (linkedCell.settings.cellId == cell.id) {
                    this.value.content.pages[index].cells.splice(i, 1);
                    break;
                }
            }
        },
        removeStepIfEmpty(index) {
            if (this.value.content.pages[index].cells.length <= 0) {
                this.value.content.pages.splice(index, 1);
                return true;
            }

            return false;
        },
        updateStep(cell, defaults, add, before) {
            let step = this.value.content.pages[this.activePage];
            let stepIndex = this.getStepIndexByParentId(step.id, defaults.type);

            if (add) {
                if (stepIndex == null) {
                    stepIndex = this.createLinkedStep(step, defaults, before);
                }

                this.addCellToStep(stepIndex, cell, defaults);
                if (before) {
                    this.activePage = stepIndex + 1;
                } else {
                    this.activePage = stepIndex;
                }
            } else if(stepIndex != null) {
                this.removeCellFromStep(stepIndex, cell);
                let deleted = this.removeStepIfEmpty(stepIndex);
                if (before && deleted) {
                    this.activePage = stepIndex;
                }
            }
        },
        getStepIndexById(stepId) {
            for (let i = 0; i < this.value.content.pages.length; i++) {
                const page = this.value.content.pages[i];
                if (page.id == stepId) {
                    return i;
                }
            }

            return null;
        },
        getStepIndexByParentId(stepId, type) {
            for (let i = 0; i < this.value.content.pages.length; i++) {
                const page = this.value.content.pages[i];
                if (page.parentId == stepId && page.type == type) {
                    return i;
                }
            }

            return null;
        },
        updateStatusCode(page, val) {
            if (!page.nameCustom) {
                page.name = val.text;
            }

            page.cells = [];
        },
        tabDragged(val) {
            if (val.moved.oldIndex < 0 || val.moved.newIndex < 0) {
                return;
            }

            const pages = this.value.content.pages;
            const movedItem = pages.splice(val.moved.oldIndex + 1, 1)[0];
            pages.splice(val.moved.newIndex + 1, 0, movedItem);
            this.$set(this.value.content, 'pages', pages);
        },
        addPage() {
            if (!this.value.content.pages) {
                this.$set(this.value.content, 'pages', []);
            }

            // Add a new page before the last page
            this.value.content.pages.splice(this.value.content.pages.length - 1, 0, {
                id: uuidv4(),
                name: 'Formulier',
                cells: [
                    {
                        id: uuidv4(),
                        typeId: 'form',
                        name: 'Formulier',
                        settings: {
                            template: null
                        }
                    }
                ],
                statusCode: this.settings.workflowStatusCodes.find(item => item.value == 'form'),
                description: '',
                removeable: true,
                nameCustom: false,
                showCancelFormButton: true,
                showCancelWorkflowButton: true,
                textNextStepButton: 'Indienen'
            });

            this.activePage = this.value.content.pages.length - 2;
        }
    }
}
</script>